<div
  class="flex flex-col gap-4 flex-1 overflow-y-auto"
>
  @if (selectedItem(); as selectedItem) {
    <soft-page-filter-detail [item]="selectedItem"
                             [filter]="service.getDraftItemValue(selectedItem)"
                             [operator]="selectedItem.operator"></soft-page-filter-detail>
  }
  @else {
    <div class="px-6">
      <soft-ds-search-input [value]="listService.search()"
                            (valueChange)="listService.search.set($event ?? '')"
                            size="md"
                            [placeholder]="'#CORE_FILTER.SEARCH_PLACEHOLDER' | translate"
                            data-testid="page-filter-search">
      </soft-ds-search-input>
    </div>

    @if (hasComplexState()) {
      <div class="page-filter-custom-hint mx-6 flex flex-col gap-2" data-testid="page-filter-custom-hint">
        <span class="ds-caption">{{ '#CORE_FILTER.LIST.CUSTOM_FILTER_HINT' | translate }}</span>
        <soft-ds-button variant="ghost" size="xs" class="self-start"
                        (click)="switchToCustomTab()"
                        data-testid="page-filter-edit-in-custom">
          {{ '#CORE_FILTER.LIST.EDIT_IN_CUSTOM' | translate }}
        </soft-ds-button>
      </div>
    }

    @for(group of listService.list(); track group.group?.key) {
      @if (group.group) {
        <span class="soft-overline mb-3 px-6">{{group.group.title()}}</span>
      }
      @for (item of group.items; track item.field) {
        @if (!item.visible || item.visible()) {
          <div class="sidebar-filter-row-wrap px-6"
               [class.page-filter-row-disabled]="isItemDisabled(item)">
            <soft-page-filter-list-item [item]="item"
                                        [value]="service.getDraftItemValue(item)"
                                        [toggleActive]="isToggleActive(item)"
                                        (activate)="onItemClick($event)"
                                        (clearFilter)="onClearFilter($event)"></soft-page-filter-list-item>
          </div>
        }
      }
    }
    @empty {
      <p class="ds-body-2 page-filter-list-empty px-6">{{ '#CORE_FILTER.NO_RESULTS' | translate }}</p>
    }
  }
</div>
